import React from 'react';

import { Typography } from '../../designComponents';
import theme from '../../theme';
import { RolesStyled } from './style';

type Props = {
  label?: string;
  des?: string;
  id?: number;
};

const Role = ({ id, label, des }: Props) => {
  return (
    <RolesStyled>
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        {id && (
          <Typography
            style={{
              backgroundColor: theme.colors.skyGreenLight,
              borderRadius: '30px',
              width: '40px',
              height: '40px',
              display: 'flex',

              justifyContent: 'center',
              alignItems: 'center',
              color: theme.colors.white,
            }}
          >
            {id}
          </Typography>
        )}

        <div className="main-text">
          <Typography
            style={{ color: '#207FA9', fontSize: '16px', fontWeight: '500' }}
            variant="title"
          >
            {label}
          </Typography>
        </div>
      </div>
      <div style={{ marginLeft: '45px' }}>
        <Typography style={{ fontSize: '14px', fontWeight: '500' }}>
          {des}
        </Typography>
      </div>
    </RolesStyled>
  );
};

export default Role;
